import enviro from 'enviro';
export const VALIDATION_DEBOUNCE = 500;
export const PHONE_NUMBER_VALIDATION_DEBOUNCE = 500;
export const RESOLVER_DEBOUNCE = 500;
export const UPDATE_OBJECTS_DEBOUNCE = 2000;
export const AUTOSAVE_SUCCESS_DELAY = 10000;
export const AUTOSAVE_REVERT_DELAY = 3000;
export const AUTOSAVE_INDICATOR_TRANSITION_DELAY = 300;
export const VALIDATION_DEBOUNCE_KEY = 'VALIDATION_DEBOUNCE';
export const PHONE_NUMBER_VALIDATION_DEBOUNCE_KEY = 'PHONE_NUMBER_VALIDATION_DEBOUNCE';
export const RESOLVER_DEBOUNCE_KEY = 'RESOLVER_DEBOUNCE';
export const UPDATE_OBJECTS_DEBOUNCE_KEY = 'UPDATE_OBJECTS_DEBOUNCE';
export const AUTOSAVE_SUCCESS_DELAY_KEY = 'AUTOSAVE_SUCCESS_DELAY';
export const AUTOSAVE_REVERT_DELAY_KEY = 'AUTOSAVE_REVERT_DELAY';
export const AUTOSAVE_INDICATOR_TRANSITION_DELAY_KEY = 'AUTOSAVE_INDICATOR_TRANSITION_DELAY';
export const TIME_TOKENS = {
  [VALIDATION_DEBOUNCE_KEY]: VALIDATION_DEBOUNCE,
  [PHONE_NUMBER_VALIDATION_DEBOUNCE_KEY]: PHONE_NUMBER_VALIDATION_DEBOUNCE,
  [RESOLVER_DEBOUNCE_KEY]: RESOLVER_DEBOUNCE,
  [UPDATE_OBJECTS_DEBOUNCE_KEY]: UPDATE_OBJECTS_DEBOUNCE,
  [AUTOSAVE_SUCCESS_DELAY_KEY]: AUTOSAVE_SUCCESS_DELAY,
  [AUTOSAVE_REVERT_DELAY_KEY]: AUTOSAVE_REVERT_DELAY,
  [AUTOSAVE_INDICATOR_TRANSITION_DELAY_KEY]: AUTOSAVE_INDICATOR_TRANSITION_DELAY
};

/**
 * Exposed for testing purposes only. Will not work in production.
 */
export const setTimeToken = (key, duration) => {
  if (enviro.deployed()) {
    return;
  }
  TIME_TOKENS[key] = duration;
};

/**
 * Exposed for testing purposes only. Will not work in production.
 */
export const setAllTimeTokensToZero = () => {
  if (enviro.deployed()) {
    return;
  }
  Object.keys(TIME_TOKENS).forEach(key => {
    TIME_TOKENS[key] = 0;
  });
};